import { render, staticRenderFns } from "./single-user-incidents-table.vue?vue&type=template&id=3740bc99&scoped=true"
import script from "./single-user-incidents-table.vue?vue&type=script&lang=js"
export * from "./single-user-incidents-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3740bc99",
  null
  
)

export default component.exports